import { render, staticRenderFns } from "./SettlementData.vue?vue&type=template&id=0938fcc7&scoped=true&"
import script from "./SettlementData.vue?vue&type=script&lang=js&"
export * from "./SettlementData.vue?vue&type=script&lang=js&"
import style0 from "./SettlementData.vue?vue&type=style&index=0&id=0938fcc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0938fcc7",
  null
  
)

export default component.exports